import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "item flavour" }
const _hoisted_2 = { class: "itemInner" }
const _hoisted_3 = { class: "image" }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = ["srcset"]
const _hoisted_6 = ["srcset"]
const _hoisted_7 = ["srcset"]
const _hoisted_8 = ["srcset"]
const _hoisted_9 = ["src", "alt"]
const _hoisted_10 = {
  key: 1,
  src: "/assets/images/Placeholder.png",
  class: "placeholder"
}
const _hoisted_11 = ["href", "id"]
const _hoisted_12 = { class: "imageRolloverWrapper" }
const _hoisted_13 = {
  key: 0,
  class: "rolloverImage"
}
const _hoisted_14 = ["srcset"]
const _hoisted_15 = ["srcset"]
const _hoisted_16 = ["srcset"]
const _hoisted_17 = ["src", "alt"]
const _hoisted_18 = ["href", "id"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        (_ctx.result?.images?.previewImageCutout)
          ? (_openBlock(), _createElementBlock("picture", _hoisted_4, [
              _createElementVNode("source", {
                srcset: 
              _ctx.result?.images?.previewImageCutout?.url.toCropUrl(220, 260)
            ,
                media: "(min-width: 1230px)"
              }, null, 8, _hoisted_5),
              _createElementVNode("source", {
                srcset: 
              _ctx.result?.images?.previewImageCutout?.url.toCropUrl(180, 220)
            ,
                media: "(min-width: 1050px)"
              }, null, 8, _hoisted_6),
              _createElementVNode("source", {
                srcset: 
              _ctx.result?.images?.previewImageCutout?.url.toCropUrl(220, 260)
            ,
                media: "(min-width: 500px)"
              }, null, 8, _hoisted_7),
              _createElementVNode("source", {
                srcset: 
              _ctx.result?.images?.previewImageCutout?.url.toCropUrl(180, 220)
            ,
                media: "(min-width: 0px)"
              }, null, 8, _hoisted_8),
              _createElementVNode("img", {
                src: _ctx.result?.images?.previewImageCutout?.url.toCropUrl(220, 260),
                alt: _ctx.result?.images?.previewImageCutout?.altText
              }, null, 8, _hoisted_9)
            ]))
          : (_openBlock(), _createElementBlock("img", _hoisted_10))
      ]),
      (_ctx.result?.images?.previewImageRollover)
        ? (_openBlock(), _createElementBlock("a", {
            key: 0,
            href: _ctx.result.url,
            class: "rolloverHover",
            id: _ctx.result?.id
          }, [
            _createElementVNode("span", null, _toDisplayString(_ctx.result?.pageTitle), 1),
            _createElementVNode("div", _hoisted_12, [
              (_ctx.result?.images?.previewImageRollover)
                ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                    _createElementVNode("picture", null, [
                      _createElementVNode("source", {
                        srcset: 
                  _ctx.result?.images?.previewImageRollover?.url.toCropUrl(280, 360)
                ,
                        media: "(min-width: 1050px)"
                      }, null, 8, _hoisted_14),
                      _createElementVNode("source", {
                        srcset: 
                  _ctx.result?.images?.previewImageRollover?.url.toCropUrl(280, 340)
                ,
                        media: "(min-width: 500px)"
                      }, null, 8, _hoisted_15),
                      _createElementVNode("source", {
                        srcset: 
                  _ctx.result?.images?.previewImageRollover?.url.toCropUrl(215, 280)
                ,
                        media: "(min-width: 0px)"
                      }, null, 8, _hoisted_16),
                      _createElementVNode("img", {
                        src: 
                  _ctx.result?.images?.previewImageRollover?.url.toCropUrl(280, 360)
                ,
                        alt: _ctx.result?.images?.previewImageRollover?.altText,
                        role: "presentation"
                      }, null, 8, _hoisted_17)
                    ])
                  ]))
                : _createCommentVNode("", true)
            ])
          ], 8, _hoisted_11))
        : (_openBlock(), _createElementBlock("a", {
            key: 1,
            href: _ctx.result.url,
            class: "title",
            id: _ctx.result?.id
          }, [
            _createElementVNode("span", null, _toDisplayString(_ctx.result?.pageTitle), 1)
          ], 8, _hoisted_18))
    ])
  ]))
}